import { useMemo } from 'react';

import { useGetOptionsForCLA } from 'hooks/useGetOptionsForCLA';
import { useTranslation } from 'react-i18next';

import { DayLimitArrangementResponse } from 'generated/index';

import { dateFormatter } from 'components/shared/DataGrid/utils/valueFormatters/dateFormatter';

import { singleSelectValueFormatter } from 'components/shared/DataGrid/utils/valueFormatters/singleSelectValueFormatter';

import { GridColDef } from '@mui/x-data-grid-pro';

export const useGetColumnDefs = (): GridColDef[] => {
  const { t } = useTranslation('common');

  const options = useGetOptionsForCLA();

  return useMemo(
    () => [
      {
        field: 'cla.claCode',
        type: 'string',
        headerName: t('dayLimitArrangements.grid.cla'),
        hideable: false,
        valueOptions: options,
        valueFormatter: (value: string | number) =>
          singleSelectValueFormatter(value, options),
        valueGetter: (_, row: DayLimitArrangementResponse) =>
          row?.cla?.claCode ?? '',
        minWidth: 50,
        flex: 1
      },
      {
        field: 'validFrom',
        type: 'date',
        headerName: t('dayLimitArrangements.grid.validFrom'),
        width: 200,
        valueGetter: (_, row: DayLimitArrangementResponse) => row?.validFrom,
        valueFormatter: (value: string) => dateFormatter(value)
      },
      {
        field: 'validTo',
        type: 'date',
        headerName: t('dayLimitArrangements.grid.validTo'),
        width: 200,
        valueGetter: (_, row: DayLimitArrangementResponse) => row?.validTo,
        valueFormatter: (value: string) => dateFormatter(value)
      }
    ],
    [t, options]
  );
};
